import ServiceTextBox from './ServiceTextBox';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

// Actions
import {
  addService,
  removeService,
  updateTellusmoreService
} from 'store/reducers/appointment/actions';

// Selectors
import { getServices } from 'store/reducers/appointment/selectors';
import {
  getPolicyProperty,
  getTellusmoreSvcId
} from 'store/reducers/dealerSettings/selectors';

const mapStateToProps = state => {
  const getTellusmoreSvcVisible = getPolicyProperty(state);
  return {
    tellusmoreSvcId: getTellusmoreSvcId(state),
    services: getServices(state),
    tellusmoreSvcVisible: getTellusmoreSvcVisible('tellusmoreSvcVisible')
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      updateTellusmoreService,
      addService,
      removeService
    },
    dispatch
  );
}

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(ServiceTextBox);



// WEBPACK FOOTER //
// ./src/components/atoms/ServiceTextBox/ServiceTextBoxContainer.js